import { Icon } from "../../../components/BaseComponents/Icon";

export const PopoverArrowIcon = (props) => (
	<Icon viewBox="0 0 12 12" fill="none" {...props}>
		<path d="M0 0L6 6L12 0" fill="currentColor" />
	</Icon>
);
